module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Chats":"Chats","Knowledge Base":"Wissensdatenbank","Prompt Templates":"Prompt-Vorlagen"}}')
  delete Component.options._Ctor
}
